import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import fetch from 'isomorphic-fetch';
import { StickyContainer, Sticky } from 'react-sticky';
import Scroll from 'react-scroll';
import Collapsible from 'react-collapsible';
import { checkHttpStatus, parseJSON } from '../../utils';
import { setCurrentSection } from '../../actions/globalConfig';
import { LiveCamVideoResult } from '../../components';
import './styles.scss';

const propTypes = {
  statusText: PropTypes.string,
  sectionName: PropTypes.string,
  userName: PropTypes.string,
  profileImage: PropTypes.string
};

const defaultProps = {
  sectionName: 'help tutorials',
  statusText: '',
  userName: '',
  profileImage: 'https://explore.org/images/icon_avatar_default.png'
};

class HelpTutorialVideosView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      tutorialsData: {},
    };
    this.pauseVideo       = this.pauseVideo.bind(this);
    this.playingVideo     = null;
    this.handleVideoPlays = this.handleVideoPlays.bind(this);
  }

  fetchTutorialVideos() {
    return fetch(`${SERVER_URL}/get_tutorial_videos`)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(function (response) {
        let states = {}
        response.data.tutorials.map(function(playlists, index){
          Object.keys(playlists).map(function(keyName) {
            states[keyName] = true;
          });
        });

        this.setState({
          'states':        states,
          'tutorialsData': response.data,
        });

      }.bind(this))
      .catch((error) => {
        console.log(error, 'An error occurred');
        return Promise.resolve(); // TODO: we need a promise here because of the tests, find a better way
      });
  }

  componentWillMount() {
    this.fetchTutorialVideos();
    this.props.dispatch(setCurrentSection(this.props.sectionName));
  }

  goToSection(sectionClass) {
    if ( $('.'+sectionClass).hasClass('is-closed') ) {
      $('.'+sectionClass).find('.trigger-header').trigger('click');
    }
    const positionToMatch = $('.search-results-type').offset().top - $(window).scrollTop();
    var scrollTopPx = $('.result-type-header.' + sectionClass).offset().top - positionToMatch;

    Scroll.animateScroll.scrollTo(scrollTopPx, {
      smooth: true,
    });
  }

  handleVideoPlays(videoReference) {
    if (!_.isNull(this.playingVideo) && videoReference.a !== this.playingVideo.a) {
      this.playingVideo.pauseVideo();
    }
    this.playingVideo = videoReference;
  }

  pauseVideo(sectionName) {
    let sections = this.state.states;
    sections[sectionName] = !sections[sectionName];
    this.setState({
      sections: sections
    });
    if (!_.isNull(this.playingVideo)) {
      this.playingVideo.pauseVideo();
    }
  }

  render() {
    const {tutorials} = this.state.tutorialsData;
    if (!tutorials) {
      return null;
    }

    const sections         = this.state.states;
    const pauseVideo       = this.pauseVideo;
    const goToSection      = this.goToSection;
    const handleVideoPlays = this.handleVideoPlays;

    return (
      <div id="help-tutorials-page" className="results-listing-page">
        <div className="container-fluid content pt-15 u-font-foundation-roman">

          <StickyContainer className={this.state.isSearching ? "row results-wrapper no-opacity" : "row results-wrapper"}>

            <div className="col-sm-4">

              <Sticky topOffset={-65}>
                {
                  ({
                     style,
                     distanceFromBottom,
                     calculatedHeight,
                   }) => {
                    let heightFromTop = 65;
                    if(style && distanceFromBottom && calculatedHeight) {
                      style = (distanceFromBottom < 0 + heightFromTop + 10) ? _.extend(style, {
                        top: 'auto',
                        position: 'absolute',
                        bottom: 10,
                        left:15,
                      }) : _.extend(style, { top: heightFromTop });
                    }
                    return (
                      <div style={style}>
                        <div className="search-results-type text-uppercase u-textSize-18 container-top-rounded active">
                          Tutorial Type <span className="float-right u-font-foundation-light">Results</span>
                        </div>
                        {tutorials.map(function(playlists, index){
                          return (
                            <div key={index}>
                              {Object.keys(playlists).map(function(playlistTitle){
                                return (

                                  <div className="search-results-type category text-uppercase u-textSize-18"
                                       onClick={(e) => goToSection(playlistTitle)} key={playlistTitle}>
                                    {playlistTitle} <span
                                    className="float-right u-font-foundation-light">{tutorials[index][playlistTitle]['total']}</span>
                                  </div>
                                );
                              })}
                            </div>
                          );
                        })}

                      </div>
                    );
                  }
                }
              </Sticky>

            </div> {/* .col-sm-4 */}

            <div className="col-sm-8">

              {tutorials.map(function(playlists, index){
                return (
                  <div key={index} className={`section-${index}`}>
                    {Object.keys(playlists).map(function(playlistTitle){
                      return (
                        <div key={playlistTitle}>
                          <Collapsible
                            trigger={(<span className="trigger-header">{playlistTitle} <span className="u-font-foundation-light">{` | ${tutorials[index][playlistTitle]['total']}` }</span></span>)}
                            open={sections[playlistTitle]}
                            triggerClassName={`result-type-header ${playlistTitle} text-uppercase container-rounded u-textSize-18 mb-10`}
                            triggerOpenedClassName={`result-type-header ${playlistTitle} is-open text-uppercase  container-top-rounded u-textSize-18 mb-10`}
                            contentOuterClassName="info-box-content u-textSize-18"
                            contentInnerClassName="results-inner-wrapper"
                            handleTriggerClick={(e) => { pauseVideo(playlistTitle) }}
                          >
                            {tutorials[index][playlistTitle].videos && tutorials[index][playlistTitle].videos.map((video, index) => {
                              return (
                                <LiveCamVideoResult key={video.video_id} video={video} tracker={handleVideoPlays}/>
                              )
                            })}
                          </Collapsible>
                        </div>
                      );
                    })}
                  </div>
                );
              })}


            </div> {/* .col-sm-8 */}

          </StickyContainer>

        </div> {/* .container-fluid .content */}

      </div>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    userName: state.auth.userName,
    statusText: state.auth.statusText,
    previousPath: state.globalConfig.previousPath
  };
};

HelpTutorialVideosView.propTypes = propTypes;
HelpTutorialVideosView.defaultProps = defaultProps;

export default connect(mapStateToProps)(HelpTutorialVideosView);
